var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.9,90.2c-0.1,44.1-36.2,79.8-80.6,79.6C45.6,169.7,10,133.6,10,89.7c0.1-43.9,36.4-79.8,80.7-79.6 C134.4,10.2,170.1,46.3,169.9,90.2z M23.4,90c0,36.7,30,66.6,66.8,66.6c36.4,0,66.4-29.9,66.5-66.3c0.1-36.9-29.7-67-66.4-67.1 C53.5,23.4,23.4,53.3,23.4,90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8,107.1c0,6.8-0.1,13.5,0,20.3c0.1,4.7-2.1,8-6.7,8.1c-4.5,0-6.9-3-6.9-7.9c0.1-13.5,0-27.1,0-40.5 c0-4.6,1.7-7.9,6.7-8c5.1,0,6.9,3,6.8,7.8C96.7,93.5,96.8,100.3,96.8,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,51.6c-1.1,6.2-6.3,11.4-10.8,10.8c-5.2-0.6-8.5-4-9-9.1c-0.6-4.4,5.3-10.3,9.5-9C94.1,45.7,97.2,49.1,100.6,51.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/AboutIcon.e446eaa5.svg";
export { ForwardRef as ReactComponent };